import type { NormaliseFeedArea } from "./types";

export const normaliseFeedArea: NormaliseFeedArea = (area) => {
  if ("polygon" in area) return area;
  const { minX, minY, maxX, maxY } = area.rect;
  return {
    id: area.id,
    sourceLabel: area.sourceLabel,
    polygon: [
      { x: minX, y: minY },
      { x: maxX, y: minY },
      { x: maxX, y: maxY },
      { x: minX, y: maxY },
    ],
  };
};
